import { BaseService, NOME_TOKEN_ACESSO_DIRETO } from '@thema/base-servicos'

const urlModalidade = '/service/basico/modalidade/'

class ModalidadeService extends BaseService {
    constructor() {
        const config = JSON.parse(sessionStorage.getItem('config'))
        super(NOME_TOKEN_ACESSO_DIRETO, config)
    }

    getModalidade() {
        return this.conex.get(urlModalidade + 'todos/')
    }
}

export default ModalidadeService
